// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 0.5px solid #cbcbcb;
  opacity: 1;
  padding: 50px 20px 25px 20px;
  position: relative;
}

.status .summary {
  border-bottom: 0.5px solid #dadcde;
  color: #838383;
  font-size: 16px;
}

.status .total-terminal {
  border-inline: 2px dashed #dadcde;
}

.status .summary-total {
  color: #091c46;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0px;
  opacity: 1;
  margin-bottom: 0;
}

.status .total .success-value {
  color: #00865a;
  font-weight: 500;
  margin-top: 7px;
}

.status .total .failed-value {
  font-weight: 500;
  margin-top: 7px;
  color: #ff024b;
}

.status .terminal-count {
  color: #154fc9;
  font-weight: 500;
  margin-top: 7px;
}

.status .summary-heading {
  color: #154fc9;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 0;
}

.terminal-progress-summary .heading {
  color: #154fc9b3;
  font-size: 14px;
}

.terminal-progress-summary .total-value {
  color: #091c46;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0px;
  opacity: 1;
  margin-bottom: 20px;
}

.status .fa-angle-down {
  color: #016aa7;
  font-size: 16px;
  padding-left: 10px;
}

.circular-bar {
  width: 90%;
}

.circular-bar img {
  height: 40px;
}

.status .CircularProgressbar-path {
  stroke-width: 3;
}

.status .CircularProgressbar-trail {
  stroke-width: 3;
}

.status .status-param {
  position: absolute;
  top: -140px;
  left: -2px;
  margin-top: 20px;
  display: flex;
  gap: 15px;
}

.status .status-param select {
  background-color: #016aa719;
  border: 0.5px solid #016aa7;
  border-radius: 4px;
  opacity: 1;
  width: 152px;
  height: 42px;
  padding-left: 20px;
  margin-top: 23px;
}
`, "",{"version":3,"sources":["webpack://./src/view/merchant-view/transaction-dashboard/Status.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".status {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 0.5px solid #cbcbcb;\n  opacity: 1;\n  padding: 50px 20px 25px 20px;\n  position: relative;\n}\n\n.status .summary {\n  border-bottom: 0.5px solid #dadcde;\n  color: #838383;\n  font-size: 16px;\n}\n\n.status .total-terminal {\n  border-inline: 2px dashed #dadcde;\n}\n\n.status .summary-total {\n  color: #091c46;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  opacity: 1;\n  margin-bottom: 0;\n}\n\n.status .total .success-value {\n  color: #00865a;\n  font-weight: 500;\n  margin-top: 7px;\n}\n\n.status .total .failed-value {\n  font-weight: 500;\n  margin-top: 7px;\n  color: #ff024b;\n}\n\n.status .terminal-count {\n  color: #154fc9;\n  font-weight: 500;\n  margin-top: 7px;\n}\n\n.status .summary-heading {\n  color: #154fc9;\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 400;\n  margin-bottom: 0;\n}\n\n.terminal-progress-summary .heading {\n  color: #154fc9b3;\n  font-size: 14px;\n}\n\n.terminal-progress-summary .total-value {\n  color: #091c46;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  opacity: 1;\n  margin-bottom: 20px;\n}\n\n.status .fa-angle-down {\n  color: #016aa7;\n  font-size: 16px;\n  padding-left: 10px;\n}\n\n.circular-bar {\n  width: 90%;\n}\n\n.circular-bar img {\n  height: 40px;\n}\n\n.status .CircularProgressbar-path {\n  stroke-width: 3;\n}\n\n.status .CircularProgressbar-trail {\n  stroke-width: 3;\n}\n\n.status .status-param {\n  position: absolute;\n  top: -140px;\n  left: -2px;\n  margin-top: 20px;\n  display: flex;\n  gap: 15px;\n}\n\n.status .status-param select {\n  background-color: #016aa719;\n  border: 0.5px solid #016aa7;\n  border-radius: 4px;\n  opacity: 1;\n  width: 152px;\n  height: 42px;\n  padding-left: 20px;\n  margin-top: 23px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
